import Skeleton from '@elements/Loading/Skeleton';

export const SkeletonPlansSection = ({ isStateCountrySearch = false }: { isStateCountrySearch?: boolean }) => {
    return (
        <section className="px-5 pb-12 md:px-10 w-full max-w-[1280px] mx-auto">
            {/* Title and Tags Section */}
            <div className="-mx-5 mb-2 mt-2 py-5 bg-[#FFFFFF] px-5 md:-mx-10 md:px-10">
                <div className="mx-auto flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 w-full">
                    <Skeleton variant="text" width={200} height={32} className="lg:shrink-0" />
                    <div className="flex flex-wrap items-center gap-1 md:gap-2 lg:flex-1 lg:justify-end">
                        {[1, 2, 3, 4, 5, 6, 7].map((index) => (
                            <Skeleton key={index} variant="rounded" width={100} height={36} />
                        ))}
                    </div>
                </div>
            </div>

            <div className="mb-8 grid grid-cols-1 gap-4 md:grid-cols-[434px_254px] lg:grid-cols-[1fr_443px] md:items-start">
                <div className="w-full max-w-[434px] md:max-w-[434px] lg:max-w-[909px]">
                    {!isStateCountrySearch && (
                        <div
                            className="w-full rounded-xl p-4 md:p-6"
                            style={{ background: 'linear-gradient(94.57deg, #F7F8FA 0.46%, #F7F7F7 120.83%)' }}
                        >
                            <div className="grid grid-cols-6 gap-3 md:gap-6 md:grid-cols-4">
                                <div className="col-span-2 md:col-span-1 flex flex-col gap-1">
                                    <Skeleton variant="text" width={96} height={16} />
                                    <Skeleton variant="text" width={64} height={24} />
                                </div>
                                <div className="col-span-2 md:col-span-1 flex flex-col gap-1">
                                    <Skeleton variant="text" width={96} height={16} />
                                    <Skeleton variant="text" width={64} height={24} />
                                </div>
                                <div className="col-span-2 md:col-span-1 flex flex-col gap-1">
                                    <Skeleton variant="text" width={96} height={16} />
                                    <Skeleton variant="text" width={64} height={24} />
                                </div>
                                <div className="col-span-3 md:col-span-1 flex flex-col gap-1">
                                    <Skeleton variant="text" width={112} height={16} />
                                    <Skeleton variant="text" width={64} height={24} />
                                </div>

                                <div className="col-span-3 md:col-span-1 flex flex-col gap-1">
                                    <Skeleton variant="text" width={96} height={16} />
                                    <Skeleton variant="text" width={64} height={24} />
                                </div>
                                <div className="col-span-2 md:col-span-1 flex flex-col gap-1">
                                    <Skeleton variant="text" width={96} height={16} />
                                    <Skeleton variant="text" width={64} height={24} />
                                </div>
                                <div className="col-span-2 md:col-span-1 flex flex-col gap-1">
                                    <Skeleton variant="text" width={96} height={16} />
                                    <Skeleton variant="text" width={64} height={24} />
                                </div>
                                <div className="col-span-2 md:col-span-1 flex flex-col gap-1">
                                    <Skeleton variant="text" width={112} height={16} />
                                    <Skeleton variant="text" width={64} height={24} />
                                </div>
                            </div>
                        </div>
                    )}

                    <div className={`${!isStateCountrySearch ? 'mt-6' : ''} flex flex-col gap-4`}>
                        {[1, 2].map((index) => (
                            <article
                                key={index}
                                className="rounded-2xl"
                                style={{ background: 'linear-gradient(94.57deg, #F7F8FA 0.46%, #F7F7F7 120.83%)' }}
                            >
                                <div className="flex flex-row items-center justify-between gap-3 p-4 sm:p-5">
                                    <div className="w-full min-w-0">
                                        <div className="flex w-full flex-row items-center gap-2">
                                            <Skeleton variant="rounded" width={96} height={96} />
                                            <div className="hidden w-full max-w-[450px] sm:block">
                                                <Skeleton variant="text" width={192} height={16} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex shrink-0 flex-col items-end gap-2">
                                        <Skeleton variant="rounded" width={64} height={24} />
                                        <Skeleton variant="rounded" width={80} height={20} />
                                    </div>
                                </div>

                                <div
                                    className="p-3 sm:p-4 md:p-5"
                                    style={{ background: 'linear-gradient(94.57deg, #F7F8FA 0.46%, #F7F7F7 120.83%)' }}
                                >
                                    <div className="mb-1 w-full overflow-hidden">
                                        <div className="flex flex-col md:flex-row items-start gap-3 sm:gap-2 md:gap-4 w-full overflow-hidden">
                                            <div className="flex w-full md:w-[20%] flex-col md:pr-4 md:shrink-0 min-w-0 overflow-hidden">
                                                <Skeleton variant="text" width={48} height={16} className="mb-1" />
                                                <Skeleton variant="text" width={80} height={20} />
                                            </div>
                                            <div className="flex w-full md:w-auto flex-col md:pr-4 md:shrink-0 min-w-0 overflow-hidden">
                                                <Skeleton variant="text" width={64} height={16} className="mb-1" />
                                                <Skeleton variant="text" width={96} height={20} />
                                            </div>
                                            <div className="flex w-full md:w-auto flex-col md:pr-4 md:shrink-0 min-w-0 overflow-hidden">
                                                <Skeleton variant="text" width={128} height={16} className="mb-1" />
                                                <Skeleton variant="text" width={96} height={20} />
                                            </div>
                                            <div className="flex w-full md:w-auto flex-col gap-1 md:pr-4 md:shrink-0 min-w-0 overflow-hidden">
                                                <Skeleton variant="text" width={96} height={16} />
                                                <Skeleton variant="text" width={128} height={16} />
                                            </div>
                                            <div className="hidden md:flex md:w-auto md:ml-auto flex-col items-center justify-center gap-1 shrink-0 self-center">
                                                <Skeleton variant="text" width={96} height={20} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="w-full md:col-span-3">
                                        <div className="mt-3 flex w-full flex-col items-start gap-4 sm:flex-row sm:flex-wrap sm:items-center sm:justify-between sm:gap-x-6 sm:gap-y-2">
                                            <Skeleton variant="text" width={160} height={16} />
                                            <Skeleton variant="text" width={192} height={16} />
                                            <Skeleton variant="text" width={128} height={16} />
                                            <Skeleton variant="text" width={144} height={16} />
                                        </div>
                                    </div>

                                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-4">
                                        <div className="flex flex-col gap-1">
                                            <Skeleton variant="text" width={128} height={16} />
                                            <Skeleton variant="text" width={96} height={32} />
                                        </div>
                                        <Skeleton variant="rounded" width={128} height={40} />
                                    </div>
                                </div>
                            </article>
                        ))}
                    </div>
                </div>

                <div className="order-first md:order-0">
                    {/* SortBy Dropdown Skeleton */}
                    <div className="mb-4 hidden md:block">
                        <Skeleton variant="rounded" width="100%" height={56} />
                    </div>
                    {/* Filters Panel Skeleton */}
                    <div
                        className="rounded-2xl p-4"
                        style={{ background: 'linear-gradient(94.57deg, #F7F8FA 0.46%, #F7F7F7 120.83%)' }}
                    >
                        {[1, 2, 3, 4].map((index) => (
                            <div key={index} className="mb-4 last:mb-0">
                                <Skeleton variant="text" width={128} height={20} className="mb-3" />
                                <div className="space-y-2">
                                    <Skeleton variant="rounded" width="100%" height={32} />
                                    <Skeleton variant="rounded" width="100%" height={32} />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};
